const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export async function sendAuthRequest({ email, password, mode, name }) {
  const body = {
    email,
    password,
    mode,
    ...(mode === 'register' && name ? { name } : {}) // добавляем name только при регистрации
  };

  const response = await fetch(`${API_BASE_URL}/auth`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || 'Ошибка авторизации');
  }

  return data;
}

export async function fetchUserById(userId) {
  if (!userId) throw new Error('userId обязателен');

  const response = await fetch(`${API_BASE_URL}/get-user`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ userId }),
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || 'Ошибка при получении пользователя');
  }

  return data;
}

export async function restorePassword(email) {
  if (!email) throw new Error('Поле email обязательно');

  const response = await fetch(`${API_BASE_URL}/restore-password`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email }),
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || 'Ошибка при восстановлении пароля');
  }

  return data; // { message: 'Новый пароль отправлен на email' }
}



